import {
  CALL_AGENT_NUMBERS_REQUEST,
  CALL_AGENT_NUMBERS_SUCCESS,
  CALL_AGENT_NUMBERS_FAILURE,
  CALL_AGENT_PURCHASE_REQUEST,
  CALL_AGENT_PURCHASE_SUCCESS,
  CALL_AGENT_PURCHASE_FAILURE,
  CALL_AGENT_CANCEL_PLAN_REQUEST,
  CALL_AGENT_CANCEL_PLAN_SUCCESS,
  CALL_AGENT_CANCEL_PLAN_FAILURE,
  FETCH_CURRENT_SUBSCRIPTION_REQUEST,
  FETCH_CURRENT_SUBSCRIPTION_SUCCESS,
  FETCH_CURRENT_SUBSCRIPTION_FAILURE,
  FETCH_PLANS_REQUEST,
  FETCH_PLANS_SUCCESS,
  FETCH_PLANS_FAILURE,
} from '../actions/callAgentActions';

const initialState = {
  numbers: [],
  loading: false,
  error: null,
  page: 1,
  limit: 25,
  total: 0,
  purchasing: false,
  purchaseError: null,
  cancelingPlan: false,
  cancelPlanError: null,
  currentSubscription: null,
  subscriptionLoading: false,
  subscriptionError: null,
  plans: [],
  plansLoading: false,
  plansError: null,
};

export default function callAgent(state = initialState, action) {
  switch (action.type) {
    case CALL_AGENT_NUMBERS_REQUEST:
      return { ...state, loading: true, error: null };
    case CALL_AGENT_NUMBERS_SUCCESS:
      return {
        ...state,
        loading: false,
        numbers: action.append ? [...state.numbers, ...action.payload.items] : action.payload.items,
        page: action.payload.page,
        limit: action.payload.limit,
        total: action.payload.total,
      };
    case CALL_AGENT_NUMBERS_FAILURE:
      return { ...state, loading: false, error: action.error };
    case CALL_AGENT_PURCHASE_REQUEST:
      return { ...state, purchasing: true, purchaseError: null };
    case CALL_AGENT_PURCHASE_SUCCESS:
      return { ...state, purchasing: false };
    case CALL_AGENT_PURCHASE_FAILURE:
      return { ...state, purchasing: false, purchaseError: action.error };
    case CALL_AGENT_CANCEL_PLAN_REQUEST:
      return { ...state, cancelingPlan: true, cancelPlanError: null };
    case CALL_AGENT_CANCEL_PLAN_SUCCESS:
      return { ...state, cancelingPlan: false };
    case CALL_AGENT_CANCEL_PLAN_FAILURE:
      return { ...state, cancelingPlan: false, cancelPlanError: action.error };
    case FETCH_CURRENT_SUBSCRIPTION_REQUEST:
      return { ...state, subscriptionLoading: true, subscriptionError: null };
    case FETCH_CURRENT_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        subscriptionLoading: false,
        currentSubscription: action.payload,
        subscriptionError: null
      };
    case FETCH_CURRENT_SUBSCRIPTION_FAILURE:
      return {
        ...state,
        subscriptionLoading: false,
        currentSubscription: null,
        subscriptionError: action.error
      };
    case FETCH_PLANS_REQUEST:
      return { ...state, plansLoading: true, plansError: null };
    case FETCH_PLANS_SUCCESS:
      return {
        ...state,
        plansLoading: false,
        plans: action.payload,
        plansError: null
      };
    case FETCH_PLANS_FAILURE:
      return {
        ...state,
        plansLoading: false,
        plansError: action.error
      };
    default:
      return state;
  }
}


